import { faEye, faEyeSlash, faFileLines, faPaperclip, faPlus, faTrashCan, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import * as Constants from "../../../../../Helper/constants/constants";
import WithoutImageHeader from "../../../../../Helper/withoutImageHeader";
import Select from 'react-select';
import AddReportFunction from "./function";
import { useEffect } from "react";

const AddReportBioOne = () => {
    const breadcrumData = ['Dashboard', 'Patient Detail'];
    const breadcrumItem = ['Add Report'];

    const {
        values,
        loader,
        loaction,
        navigate,
        isError,
        handleChange,
        handleChange1,
        submitReport,
        addCategories,
        deleteCategories,
        getTestTypeListing,
        testTyleList,
        testNameList,
        testCategoryList
    } = AddReportFunction() 

    useEffect(() => {
        getTestTypeListing();
    },[])

    const options = [
        { label: 'Hematology' },
        { label: 'Biochemistry' },
        { label: 'Hormons' },
        { label: 'Urine Normal Range' },
    ]
    const list = [
        { label: 'CBC' },
        { label: 'ABG' },
        { label: 'ESR' },
        { label: 'HbA1c' },
        { label: 'BLEEDING TIME' },
        { label: 'CLOTTING TIME' },
        { label: 'Trop-T' },
        { label: 'trop-I' },
        { label: 'CALCIUM' },
    ]
    const Category = [
        { label: 'Hb' },
        { label: 'TLC' },
        { label: 'DLC' },
        { label: 'GRANULOCYTE' },
        { label: 'LYMPHOCYTS' },
        { label: 'MONOCYTES' },
        { label: 'EOSINPHILS' },
    ];
  
    return (
        <div className="add_Report_hemotology manage_select_react">
            <WithoutImageHeader header={Constants.ADD_REPORT}
                lefticon={'menu'}
                breadcrumData={breadcrumData}
                breadcrumItem={breadcrumItem}
            />
            <Container>
                <Row>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <div className="report_main_area">
                            <div className="inner_area">
                                <div className="dropdown_box">
                                    <h6>Test Type<span>*</span></h6>
                                    <div className="dropdown_area">
                                        <Select
                                            placeholder="Select"
                                            value={values && values.testType}
                                            options={testTyleList ? testTyleList :[]}
                                            onChange={(e)=>handleChange('testType',e)}
                                            className={ isError.testType.message ? "error_border_select" : ""}
                                        />
                                        {isError && isError.testType.message ? (
                                         <p className="text-danger mt-2">
                                             {isError && isError.testType.message}
                                         </p>
                                           ) : null}
                                    </div>
                                </div>

                                {values && values.testType ?
                                    <div className="dropdown_box">
                                    <h6>Test Name<span>*</span></h6>
                                    <div className="dropdown_area">
                                        <Select
                                            placeholder="Select"
                                            value={values && values.testName}
                                            options={testNameList ? testNameList : []}
                                            onChange={(e)=>handleChange('testName',e)}
                                            className={isError.testName.message ? "error_border_select" : ""}
                                        />
                                         {isError && isError.testName.message ? (
                                         <p className="text-danger mt-2">
                                             {isError && isError.testName.message}
                                         </p>
                                           ) : null}
                                    </div>
                                </div>: null}

                                {values && values.testName && values.test ?
                                    values.test.map((item, index) => {
                                        return (
                                    <Row>
                                        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                                            <div className="dropdown_box">
                                                <h6>Test Category<span>*</span></h6>
                                                <div className="dropdown_area">
                                                    <Select
                                                        placeholder="Select"
                                                        options={testCategoryList ? testCategoryList : []}
                                                        value={item && item.testCategory}
                                                        onChange={(e)=>handleChange1(index,'testCategory',e)}
                                                        className={item && item.error_test  ? "error_border_select" : ""}
                                                    />
                                                    {item && item.error_test ? (
                                                    <p className="text-danger mt-2">
                                                        {"This field is required"}
                                                    </p>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xxl={7} xl={7} lg={7} md={7} sm={12} xs={12}>
                                            <div className="form_div_area">
                                                <div className="left_area">
                                                    <Form>
                                                        <Form.Group className="form-group">
                                                                    <Form.Label>Range<span>*</span>
                                                                        {item && item.testCategory && item.testCategory.test_units ? item.testCategory.test_units : null}</Form.Label>
                                                                    <Form.Control
                                                                    type="number"
                                                                    placeholder={item && item.testCategory && item.testCategory.test_range ? item.testCategory.test_range : "Enter Value" }
                                                                    value={item && item.range}
                                                                    onChange={(e)=>handleChange1(index,'range',e.target.value)}
                                                                    className={item && item.error_range ? "error_border_select" : ""}
                                                            />
                                                             {item && item.error_range ? (
                                                            <p className="text-danger mt-2">
                                                                {"This field is required"}
                                                            </p>
                                                            ) : null}
                                                        </Form.Group>
                                                    </Form>
                                                        </div>
                                                        {index == 0 ?
                                                          <div className="right_area">
                                                    <a href="javscript:;">
                                                        <div className="plus_box">
                                                                <FontAwesomeIcon icon={faPlus} className="icon_plus"
                                                                    onClick={()=>addCategories()}
                                                                />
                                                        </div>
                                                     </a>
                                                     </div>
                                                            : (
                                                            <div className="right_area">
                                                                <a href="javscript:;">
                                                                    <div className="plus_box">
                                                                        <FontAwesomeIcon icon={faTrashCan} className="icon_plus" onClick={()=>deleteCategories(item)}/>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            ) }
                                                        
                                                   </div>
                                        </Col>
                                    </Row> 
                                        )
                                    }): null}
                                
                                 <div className="dropdown_box">
                                    <h6>Test Category<span>*</span></h6>
                                    <div className="dropdown_area">
                                        <Select
                                            placeholder="Select"
                                            options={Category}
                                        />
                                    </div>
                                </div>
                                <Row>
                                    <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                                        <div className="dropdown_box">
                                            <h6>Sub Category ( Bilirubin )<span>*</span></h6>
                                            <div className="dropdown_area">
                                                <Select
                                                    placeholder="Select"
                                                    options={Category}
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xxl={7} xl={7} lg={7} md={7} sm={12} xs={12}>
                                        <div className="form_btns_area">
                                            <div className="left_area">
                                                <Form>
                                                    <Form.Group className="form-group">
                                                        <Form.Label>Range<span>*</span> ( mg/dl )</Form.Label>
                                                        <Form.Control
                                                            placeholder="Enter Value"
                                                            value={'Enter Value'}
                                                        />
                                                    </Form.Group>
                                                </Form>
                                            </div>
                                            <div className="right_area">
                                                <div className="icons_main">
                                                    <div>
                                                        <a href="javscript:;">
                                                            <div className="plus_box">
                                                                <FontAwesomeIcon icon={faPlus} className="icon_plus" />
                                                            </div>
                                                        </a>
                                                    </div>
                                                    <div>
                                                        <a href="javscript:;">
                                                            <div className="plus_box space_area">
                                                                <FontAwesomeIcon icon={faTrashCan} className="icon_plus" />
                                                            </div>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                                        <div className="dropdown_box">
                                            <h6>Test Category<span>*</span></h6>
                                            <div className="dropdown_area">
                                                <Select
                                                    placeholder="Select"
                                                    options={Category}
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xxl={7} xl={7} lg={7} md={7} sm={12} xs={12}>
                                        <div className="form_div_area">
                                            <div className="left_area">
                                                <Form>
                                                    <Form.Group className="form-group">
                                                        <Form.Label>Range<span>*</span> ( mg/dl )</Form.Label>
                                                        <Form.Control
                                                            placeholder="Enter Value"
                                                            value={'Enter Value'}
                                                        />
                                                    </Form.Group>
                                                </Form>
                                            </div>
                                            <div className="right_area">
                                                <a href="javscript:;">
                                                    <div className="plus_box">
                                                        <FontAwesomeIcon icon={faTrashCan} className="icon_plus" />
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                               
                            </div>
                             <div className="upload_img_area">
                                {/* Before-Upload_file */}
                               <div className="before_upload_area">
                                    <div className="text_area"><FontAwesomeIcon icon={faPaperclip} className="icon_area" />Upload File</div>
                                </div>

                                {/* After- Upload_file */}
                                {/* <div className="after_upload_area">
                                    <div className="inner_img_area">
                                        <div className="icon_text_area">
                                            <FontAwesomeIcon icon={faPaperclip} className="icon" />
                                            <p>Upload File</p>
                                        </div>
                                    </div>
                                    <div className="inner_img_area upload_file">
                                        <div className="icon_text_area">
                                            <FontAwesomeIcon icon={faFileLines} className="icon" />
                                            <p>file.pdf</p>
                                        </div>
                                        <div className="cross_icon">
                                            <FontAwesomeIcon icon={faXmark} />
                                        </div>
                                    </div>
                                    <div className="inner_img_area upload_file">
                                        <div className="icon_text_area">
                                            <FontAwesomeIcon icon={faFileLines} className="icon" />
                                            <p>file.pdf</p>
                                        </div>
                                        <div className="cross_icon">
                                            <FontAwesomeIcon icon={faXmark} />
                                        </div>
                                    </div>
                                    <div className="inner_img_area upload_file">
                                        <div className="icon_text_area">
                                            <FontAwesomeIcon icon={faFileLines} className="icon" />
                                            <p>file.pdf</p>
                                        </div>
                                        <div className="cross_icon">
                                            <FontAwesomeIcon icon={faXmark} />
                                        </div>
                                    </div>
                                    <div className="inner_img_area upload_file">
                                        <div className="icon_text_area">
                                            <FontAwesomeIcon icon={faFileLines} className="icon" />
                                            <p>file.pdf</p>
                                        </div>
                                        <div className="cross_icon">
                                            <FontAwesomeIcon icon={faXmark} />
                                        </div>
                                    </div>
                                </div> */}
                            </div>

                            <div className="btn_area">
                                <Button
                                    className="cancelBtn"
                                    type="button"
                                    onClick={()=>navigate(-1)}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    className="submitBtn"
                                    type="button"
                                    onClick={()=>submitReport()}
                                >
                                    Submit
                                </Button>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div >
    );
};

export default AddReportBioOne;